import React from 'react';

const EmptyBanner: React.FC = () => {
  return (
    <div className="mb-3 flex items-center justify-center gap-[14px] rounded-[10px] border-[1.5px] border-dashed border-[#cbd5e1] bg-gradient-to-b from-[#f8fafc] to-[#f1f5f9] px-[22px] py-[18px]">
      <div className="text-[26px] leading-none">📭</div>
      <div>
        <div className="text-[14px] font-semibold leading-[1.4] text-[#334155]">
          暂无预测数据
        </div>
        <div className="mt-[2px] text-[11.5px] leading-[1.45] text-[#94a3b8]">
          本页面默认进入缺省态，需点击右上角【🔄 立即预测】生成本次预测结果
          <span className="ml-[6px] inline-block text-[14px] font-semibold text-[#2563eb] animate-pulse">
            →
          </span>
        </div>
      </div>
    </div>
  );
};

export default EmptyBanner;
